import { z } from 'zod/v4';

import { normalizeMenuWidgetArgs } from './menu-widget-args.normalization';
import { partialMenuWidgetDataSchema } from './partial-menu-widget-data.schema';

const updateMenuWidgetObjectSchema = z.object({
    widgetId: z.string().describe('Id of the menu widget to update.'),
    data: partialMenuWidgetDataSchema.describe(
        'Partial patch — only the fields you provide are changed, everything else is left as-is. ' +
            '"menuList", if provided, replaces the whole list.'
    ),
});

export const updateMenuWidgetArgsSchema = z.preprocess(normalizeMenuWidgetArgs, updateMenuWidgetObjectSchema);
